import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

const SITE_URL = "https://www.conveyorbelts.ro";
const DEFAULT_IMAGE = "/og-logo.png";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]`;
  let el = document.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const Seo = ({ pageKey }) => {
  const { lang, t } = useLang();
  const { pathname } = useLocation();

  useEffect(() => {
    const seoBlock = t.seo?.[pageKey] || t.seo?.home || {};
    const {
      title,
      description,
      keywords,
      ogImage = DEFAULT_IMAGE,
    } = seoBlock;

    if (title) document.title = title;

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow, max-image-preview:large");

    // Open Graph
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:url", `${SITE_URL}${pathname}`);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Conveyor Belts S.R.L.");
    setMeta("property", "og:locale", lang === "en" ? "en_US" : "ro_RO");

    // Twitter
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    // Canonical + hreflang
    const canonical = `${SITE_URL}${pathname}${lang === "en" ? "?lang=en" : ""}`;
    setLink("canonical", canonical);
    setLink("alternate", `${SITE_URL}${pathname}`, "ro");
    setLink("alternate", `${SITE_URL}${pathname}?lang=en`, "en");
    setLink("alternate", `${SITE_URL}${pathname}`, "x-default");

    // <html lang>
    document.documentElement.lang = lang;
  }, [pageKey, lang, pathname, t]);

  return null;
};

export default Seo;
